/* Homepage content only. Uses the existing shop assistant and shipping ticker. */
(() => {
  function init(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const tabs = [...root.querySelectorAll('[data-product-tab]')];
    const categories = {
      innen: ['Innenfarben', 'wohnraum'], aussen: ['Fassadenfarben', 'fassadenfarben-fassade'],
      putze: ['Fassadenputze', 'aussenputz-putze'], lacke: ['Lacke', 'lacke-fenster-turen-1']
    };
    function select(tab) {
      const key = tab.dataset.productTab;
      tabs.forEach(button => { button.setAttribute('aria-selected', String(button === tab)); button.tabIndex = button === tab ? 0 : -1; });
      root.querySelectorAll('[data-product-panel]').forEach(panel => { panel.hidden = panel.dataset.productPanel !== key; });
      const all = root.querySelector('#fb-products-all');
      all.textContent = 'Alle ' + categories[key][0] + ' →';
      all.href = '/collections/' + categories[key][1];
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault(); select(tabs[next]); tabs[next].focus();
      });
    });
    root.querySelectorAll('[data-color]').forEach(button => button.addEventListener('click', () => {
      root.querySelectorAll('[data-color]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
      root.querySelector('#fb-room').style.background = button.dataset.color;
      root.querySelector('#fb-color-name').textContent = button.dataset.name;
    }));
    root.querySelectorAll('[data-chat]').forEach(button => button.addEventListener('click', () => {
      const fab = document.getElementById('saa-fab');
      const panel = document.getElementById('saa-panel');
      if (fab && panel) {
        if (!panel.classList.contains('saa-panel--open')) fab.click();
      } else {
        window.location.assign('/pages/projektberater');
      }
    }));
function fbShippingState(now = new Date()) {
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Berlin', weekday: 'short', hour: '2-digit',
    minute: '2-digit', hourCycle: 'h23'
  }).formatToParts(now).map(p => [p.type, p.value]));
  const day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(parts.weekday);
  const minutes = Number(parts.hour) * 60 + Number(parts.minute);
  const cutoff = day >= 1 && day <= 4 ? 840 : day === 5 ? 600 : null;
  if (cutoff !== null && minutes < cutoff) {
    const remaining = cutoff - minutes;
    const h = Math.floor(remaining / 60), m = remaining % 60;
    return {
      title: `Versand heute bis ${cutoff / 60} Uhr`,
      sub: `Bestell in ${h ? h + ' Std ' : ''}${m} Min`
    };
  }
  return {
    title: day >= 1 && day <= 4 ? 'Versand morgen früh' : 'Versand am Montag',
    sub: 'Jetzt bestellen'
  };
}
    function updateHomeShipping() {
      if (!root.isConnected) { clearInterval(timer); return; }
      const state = fbShippingState();
      root.querySelector('[data-home-shipping-title]').textContent = state.title;
      root.querySelector('[data-home-shipping-sub]').textContent = state.sub;
    }
    let timer;
    updateHomeShipping();
    timer = setInterval(updateHomeShipping, 30000);
  }
  init(document.getElementById('fb-home-v3'));
  document.addEventListener('shopify:section:load', () => init(document.getElementById('fb-home-v3')));
})();
